import "../../i18n/i18n";
import { VehiclesTable } from "./vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ButtonDS, Spacer, triggerToast } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import {
  connectVehiclesToProviderAsync,
  selectConnectVehiclesToProviderStatus,
} from "./telemetrySlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { Vehicle, VehicleDisplayed } from "./telemetryApi";

export const AddToProviderTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const params = useParams();
  const vehiclesListWithId = useVehicles();
  const [selectedVehicles, setSelectedVehicles] = useState<VehicleDisplayed[]>(
    [],
  );
  const connectVehiclesToProviderStatus = useAppSelector(
    selectConnectVehiclesToProviderStatus,
  );

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter(
      (v) =>
        v.isEligible &&
        v.isEligible.toString() ===
          t("vehiclesOfACompany.column.isEligible.true") &&
        v.connectionStatus ===
          t("vehiclesOfACompany.column.connectionStatus.IDLE"),
    );
  }, [t, vehiclesListWithId]);

  const addToProvider = useCallback(() => {
    void dispatch(
      connectVehiclesToProviderAsync({
        vehicleUuids: selectedVehicles.map(
          (v) => (v as unknown as Vehicle).uuid,
        ),
      }),
    );
  }, [selectedVehicles, dispatch]);

  const checkVehiclesEligibilityAction = useMemo(() => {
    return (
      <ButtonDS
        text={t("telemetry.addToProvider.button")}
        format="fill"
        buttonType="primary"
        onClick={addToProvider}
        disabled={selectedVehicles.length === 0}
      />
    );
  }, [t, addToProvider, selectedVehicles.length]);

  useEffect(() => {
    if (connectVehiclesToProviderStatus === "success") {
      triggerToast(t("telemetry.addToProvider.success") || "", "valid");
    } else if (connectVehiclesToProviderStatus === "failed") {
      triggerToast(t("telemetry.addToProvider.failure") || "", "error");
    }
  }, [connectVehiclesToProviderStatus, t]);

  if (params.tab !== "addToProvider") {
    return;
  }

  return (
    <>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addToProvider.description")}
      </StyledDescription>
      <Spacer y={1} />
      <VehiclesTable
        vehiclesListWithId={filteredVehiclesListWithId}
        pageName="vehiclesOfACompany"
        pageTitle="Add-to-provider"
        action={checkVehiclesEligibilityAction}
        rowsChecked={selectedVehicles}
        setRowsChecked={setSelectedVehicles}
      />
    </>
  );
};

const StyledDescription = styled.div`
  ${typographies["Header/H3"]}
`;
